var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-lightGray",class:[_vm.width, _vm.barBg]},[_c('div',{staticClass:"h-6 bg-brandRed",class:[_vm.height, _vm.progressColor],style:(`width:${_vm.progress}%;`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }